import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { Redirect, Route } from "react-router-dom";
import Spinner from "../Components/UI/Spinner/Spinner";
import { isSignedIn } from "../Store/Selectors/isSignedIn";

function ProtectedRoute({ render = () => {}, ...restProps }) {
    const [isReady, setIsReady] = useState(true);
    // A guest token is an identity for the conversation, not an account.
    // Gating on isLoggedIn alone let every visitor through this route, because
    // every visitor is handed a guest identity automatically.
    const signedIn = useSelector(state => isSignedIn(state.auth));

    useEffect(() => {
        setIsReady(false);
    }, []);

    if (isReady) {
        return <Spinner fullHeight />;
    }

    return (
        <Route
            {...restProps}
            render={props =>
                signedIn ? (
                    render(props)
                ) : (
                    <Redirect
                        to={{
                            pathname: "/login",
                            state: { from: props.location },
                        }}
                    />
                )
            }
        />
    );
}

export default ProtectedRoute;
